import { ApiBase } from "~/extensions/api";
import { FindInformationCommand } from "./FindInformationCommand";
export class TopApi extends ApiBase {
    findMenubarLinks() {
        return this.api.get("top/menubar");
    }
    findTopLinks() {
        return this.api.get("top");
    }
    findTopInfomation() {
        let command = new FindInformationCommand();
        return this.request(command);
    }
}
